export default __webpack_public_path__ + "static/Graphik-Bold-Web-ade966bb4b4f2f0cea311170539d409c.woff2";